var CartItemComponent = Vue.component('cart-item', {
    props: ['item'],
    data: function () {
        return {};
    },
    computed: {
        itemPrice: function () {
            return Format.price(this.item.price);
        },
        itemPriceVat: function () {
            return Format.price(this.item.price_vat);
        },
        itemPriceFinal: function () {
            return Format.price(Eshop.options.pricesWithVat ? this.item.price_vat * this.item.quantity : this.item.price * this.item.quantity);
        }
    },
    methods: {
        remove: function (cartId) {
            var _self = this,
                elem = _self.$refs['remove_' + cartId],
                confirmTitle = 'Skutočne chcete odstrániť tento produkt?',
                confirmText = '';
                confirmBtnText = 'Ok';
                cancelBtnText = 'Zrušiť';

            if (elem && elem[0].dataset) {
                confirmTitle = elem[0].dataset.message || confirmTitle,
                confirmText = elem[0].dataset.text || confirmText;
                confirmBtnText = elem[0].dataset.confirmBtn || confirmBtnText;
                cancelBtnText = elem[0].dataset.cancelBtn || cancelBtnText;
            }

            Eshop.confirm(confirmTitle, {
                text: confirmText,
                cancelButtonText: cancelBtnText,
                confirmButtonText: confirmBtnText
            }, function () {
                _self.$emit('remove', cartId);
            });
        },
        changeQuantity: function () {

        }
    }
});
